import { render, staticRenderFns } from "./promot.vue?vue&type=template&id=e897dba0&scoped=true"
import script from "./promot.vue?vue&type=script&lang=js"
export * from "./promot.vue?vue&type=script&lang=js"
import style0 from "./promot.vue?vue&type=style&index=0&id=e897dba0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e897dba0",
  null
  
)

export default component.exports